import * as yup from 'yup';

const singleEmailSchema = yup.string().email();

const hasValidDomain = (email: string) => {
  const domain = email.split('@')[1];
  return Boolean(
    domain &&
      domain.includes('.') &&
      !domain.startsWith('.') &&
      !domain.endsWith('.') &&
      !domain.includes('..'),
  );
};

const isSingleOrMultipleEmailsValid = (value: string | undefined | null) => {
  if (!value) return true;
  const separators = /[,;]+/;
  const emails = value
    .split(separators)
    .map((e) => e.trim())
    .filter(Boolean);
  if (!emails.length) return false;
  return emails.every((email) => singleEmailSchema.isValidSync(email) && hasValidDomain(email));
};

export const createValidationSchema = (): yup.AnyObjectSchema => {
  return yup.object({
    companyName: yup.string().required('common.not_empty').max(64, 'article.description_maxLen'),
    // Backend-required numeric fields (fieldsMap in saveWA_Bakery2bSettings.ts). Clearing
    // one yields null (FormNumericField emits `e || null`); without a required rule the
    // blur auto-save still fires and the backend skips the nullish-required field, leaving
    // an empty `SET` clause → MySQL 1064 (WA-3708). Flag them so the doomed save never fires.
    orderFutureDays: yup.number().required('common.not_empty'),
    orderMinimalValue: yup.number().required('common.not_empty'),
    emailForOrderNotifications: yup
      .string()
      .nullable()
      .max(1000, 'settings.email_for_order_notifications_maxLen')
      .test('emails-valid', 'common.enter_valid_email', isSingleOrMultipleEmailsValid),
  });
};
